import type { EntityDetailMetadata } from '@zag/ui';

export const PERSON_DETAIL_METADATA = [
  {
    entity: 'person',
    route: '/persons/:id/edit',
    titleKey: 'navigation.persons',
    sections: [
      { id: 'basic-info', titleKey: 'person.sections.basicInfo' },
      {
        id: 'user-account',
        titleKey: 'person.sections.userAccount',
        visibleWhen: { mode: 'all', permissions: ['rbac:users:update'] },
        requiresEntityId: true,
      },
      { id: 'address', titleKey: 'person.sections.address', visibleWhen: { mode: 'all', permissions: ['employees:address:read'] } },
      { id: 'contacts', titleKey: 'person.sections.contacts', visibleWhen: { mode: 'all', permissions: ['employees:contacts:read'] } },
      {
        id: 'teams',
        titleKey: 'person.sections.teams',
        visibleWhen: { mode: 'all', permissions: ['employees:teams:read'] },
        requiresEntityId: true,
      },
      {
        id: 'skills',
        titleKey: 'person.sections.skills',
        visibleWhen: { mode: 'all', permissions: ['employees:skills:read'] },
        requiresEntityId: true,
      },
      {
        id: 'locations',
        titleKey: 'person.sections.locations',
        visibleWhen: { mode: 'all', permissions: ['employees:teams:read'] },
        requiresEntityId: true,
      },
      {
        id: 'employment',
        titleKey: 'person.sections.employment',
        visibleWhen: { mode: 'any', permissions: ['timetracking:periods:read'] },
        requiresEntityId: true,
      },
      {
        id: 'time-tracking',
        titleKey: 'person.sections.timetracking',
        visibleWhen: { mode: 'any', permissions: ['employees:balances:read', 'timetracking:manual-bookings:read'] },
        requiresEntityId: true,
      },
      {
        id: 'custom-properties',
        titleKey: 'common.customProperties.sectionTitle',
        visibleWhen: { mode: 'all', permissions: ['employees:read'] },
        requiresEntityId: true,
      },
      {
        id: 'balance',
        titleKey: 'person.sections.balance',
        visibleWhen: { mode: 'all', permissions: ['employees:balances:read'] },
        requiresEntityId: true,
      },
      {
        id: 'calendar',
        titleKey: 'persons.calendar.title',
        visibleWhen: { mode: 'all', permissions: ['calendars:read'] },
        requiresEntityId: true,
      },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['employees:update'] }, intent: 'mutation' },
      {
        id: 'activate-user-account',
        labelKey: 'settings.users.userAccount.activate',
        sectionId: 'user-account',
        visibleWhen: { mode: 'all', permissions: ['rbac:users:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['employees:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
